import * as React from 'react';
export const halifaxSvg = React.forwardRef(function halifaxSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#15569C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M1.8 8.65h11.29c.16.11.31.23.46.36H2.21l-.41-.36zm17.2 0h11.2c-.04.2-.32.35-.52.35H18.54l.46-.35zm-16.23.83h11.1c.3-.07.45.21.65.35-3.78 0-7.56.02-11.33 0l-.42-.35zm14.82.36.41-.36h11.31c-.14.13-.28.25-.43.36h-11.3zm-13.87.45c3.8 0 7.6-.01 11.38.01l.42.35H4.43c-.3.07-.48-.22-.7-.36zm12.92.36c.12-.12.25-.24.39-.35h11.34l-.49.36H16.64zm-11.93.47H16c.2.06.33.24.5.35H5.2l-.48-.35zm12.05 0h10.63c-.22.12-.39.4-.67.35h-9.55l-.41-.35zm-11.06.81h11.28c.18.08.3.24.45.36H6.18c-.2-.07-.32-.25-.48-.36zm12 0h8.73a13 13 0 0 1-.48.35h-7.78a8.09 8.09 0 0 1-.47-.35zm-11.01.82h11.28l.43.36-11.31-.01-.4-.35zm12.03 0h6.71c-.16.11-.3.3-.49.36-1.94 0-3.89.02-5.83 0l-.4-.36zM1.73 13.88h1.55v1.53h1.6v-1.53a97 97 0 0 1 1.57 0v4.28H4.86v-1.62h-1.6v1.62H1.74v-4.28zm4.89 4.3c.64-1.43 1.27-2.87 1.92-4.3h1.49c.66 1.42 1.28 2.87 1.93 4.3h-1.57c-.11-.23-.2-.47-.32-.71H8.5c-.11.24-.2.48-.32.71H6.62zm2.31-1.64h.7c-.1-.27-.21-.54-.34-.8-.15.25-.24.53-.36.8zm3.14-2.66h1.57v3.2h1.56v1.1h-3.13v-4.3zm3.42 0h1.52v4.3H15.5v-4.3zm2.12 0h3.05v.99H19.2v.56h1.4l.01 1.07c-.47.03-.94 0-1.4.01-.02.56 0 1.11-.01 1.67h-1.6v-4.3zm4.42.01h1.5c.55 1.2 1.07 2.42 1.62 3.62.4-.5.81-.97 1.2-1.47l-1.7-2.16h2.02c.25.3.48.61.72.92l.76-.92h1.75c-.53.69-1.14 1.33-1.63 2.04l1.77 2.26c-.66-.01-1.34.03-2-.02a37.2 37.2 0 0 0-.8-1.02l-.85 1.04c-.84.02-1.67.05-2.51 0-.1-.23-.2-.47-.32-.7H22l-.32.7c-.52.01-1.05.01-1.57 0l1.92-4.29zm.75 1.85-.35.81h.7c-.1-.27-.22-.54-.35-.8zM7.08 18.9h5.86c.14.11.28.23.41.36H6.64c.14-.13.29-.25.44-.36zm6.58 0h11.28c.17.1.3.24.44.35H14.13c-.18-.07-.31-.23-.47-.35zm-8.02 1.17c.21-.12.38-.39.65-.35h7.57c.2.06.34.24.51.35H5.64zm8.99-.35h11.3l.44.35H15.05l-.42-.35zm-9.45.83h9.7c.16.07.29.23.43.34H4.68c.16-.11.3-.26.5-.34zm10.39 0h11.28c.2.07.34.23.5.34h-11.3a8.96 8.96 0 0 1-.48-.35zM3.69 21.7l.48-.35h11.27l-.41.36-11.34-.01zm12.87-.35h11.3c.16.1.32.22.48.35H16.98a8.54 8.54 0 0 1-.42-.35zM2.76 22.5c.13-.12.27-.24.42-.35h11.3c-.2.13-.35.4-.62.35H2.76zm14.78-.34 11.32-.01.44.35H18.13c-.26.05-.4-.23-.59-.34zM2.24 23h11.28l-.4.35H1.78l.44-.35zm16.26 0h11.17c.27-.04.4.24.59.36h-11.3L18.5 23z',
      }),
    ),
  );
});
halifaxSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var halifax = {
  category: 'brand',
  colorable: false,
  name: 'halifax',
  svg: halifaxSvg,
};
